import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';
import { ChartData, ChartOptions } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);


export interface PendingThings {
  PendingSeniorFeedBack: string;
  PendingMyFeedBack: string;
  PendingDiary: string;
  PendingCase: string;
  PendingNotice: string;
  PendingDecision: string;
  PendingFinalVerdict: string;
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  display = 'none';
  url: string;
  cID: string;
  modelName: string;
  ModelFor: any;
  ModuleData: any;
  ReportData: [];
  FlowData: any;
  modalURL: string;
  CallFunctionOnCloseModal: any;
  RightsID: string;
  RouteDecisionADD: string;
  RouteDecisionEdit: string;
  RouteDecisionImport: string;
  RouteNoticeADD: string;
  RouteNoticeEdit: string;
  RouteNoticeImport: string;
  RouteCaseADD: string;
  RouteCaseEdit: string;
  RouteCaseImport: string;
  RouteContactADD: string;
  RouteContactEdit: string;
  RouteContactImport: string;
  RouteOrgADD: string;
  RouteOrgEdit: string;
  RouteOrgImport: string;
  RouteDiaryADD: string;
  RouteExpenseADD: string;
  RouteLibraryEdit: string;
  UserName: string;
  Role: any;
  PendingDetail: any;
  PendingSeniorFeedBack: string;
  PendingMyFeedBack: string;
  PendingDiary: string;
  PendingCase: string;
  PendingNotice: string;
  PendingDecision: string;
  PendingFinalVerdict: string;
  MsgType: number = 0;
  ReportUrl: string;
  RadioValue: number = 1;
  monthlyPendingNotice: any;
  monthlyCases: any;
  allMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  public dueTrendData!: ChartData<'line'>;
  public dueTrendOptions!: ChartOptions<'line'>;

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,

    scales: {
      x: {
        ticks: {
          autoSkip: false
        },
        grid: {
          display: false
        }
      },

      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    },

    plugins: {
      legend: { display: true }
    }
  };

  public barChartLabels: string[] = [];
  public barChartType: string = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];

  chartData!: ChartData<'bar'>;
  chartOptions!: ChartOptions<'bar'>;
  noticeChartData!: ChartData<'line'>;
  noticeChartOptions!: ChartOptions<'line'>;
  constructor(private router: Router, private http: HttpClient, private sanitization: DomSanitizer) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.fetchRouteDataRights();
    this.UserName = localStorage.getItem('UserName');
    this.Role = localStorage.getItem('Role');
    this.PendingThings();
    this.getMonthlyPendingNotice()
    this.getMonthlyCases()

  }
  PendingThings() {
    this.http.get(this.url + 'Dashboard/Dashboard_Pending_All_Things')
      .subscribe((data) => {
        if (data == null) {
          const pendingThings: PendingThings = null;
        } else {
          const pendingThings: PendingThings = JSON.parse(data.toString())[0];
          this.PendingSeniorFeedBack = pendingThings.PendingSeniorFeedBack;
          this.PendingMyFeedBack = pendingThings.PendingMyFeedBack;
          this.PendingDiary = pendingThings.PendingDiary;
          this.PendingCase = pendingThings.PendingCase;
          this.PendingNotice = pendingThings.PendingNotice;
          this.PendingDecision = pendingThings.PendingDecision;
          this.PendingFinalVerdict = pendingThings.PendingFinalVerdict;
        }
      }
      );
  }
  getMonthlyPendingNotice() {
    this.http.get(this.url + 'dashboard/Dashboard_MonthlyPendingNotice')
      .subscribe((data: any) => {
        if (data) {
          this.monthlyPendingNotice = data.data;
          console.log(this.monthlyPendingNotice, 'this.monthlyPendingNotice');
          this.buildNoticeChart();
        }
      }
      );
  }
  getMonthlyCases() {
    this.http.get(this.url + 'dashboard/Dashboard_MonthlyCases')
      .subscribe((data: any) => {
        if (data) {
          this.monthlyCases = data.data;
          
          console.log(this.monthlyCases);
          // this.bindBarChart();
          this.buildCaseChart();
        }
      }
      );
  }
  fetchRouteDataRights() {
    this.RouteDecisionADD = this.RightsID.includes('202038001') || this.RightsID.includes('202038021') ? '/decision/0' : '/module/0';
    this.RouteNoticeADD = this.RightsID.includes('202030001') || this.RightsID.includes('202030021') ? '/notice/notice/0' : '/module/0';
    this.RouteCaseADD = this.RightsID.includes('202032001') || this.RightsID.includes('202032021') ? '/notice/case/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteContactADD = this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ? '/addorgcontact/0/0' : '/module/0';
    this.RouteOrgADD = this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ? '/addorgcontact/1/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteDecisionEdit = this.RightsID.includes('202038000') || this.RightsID.includes('202038001') || this.RightsID.includes('202038021') ? '/plan/plan/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteDiaryADD = this.RightsID.includes('202030000') || this.RightsID.includes('202030001') || this.RightsID.includes('202030021') ? '/viewdiary' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteExpenseADD = this.RightsID.includes('202030000') || this.RightsID.includes('202030001') || this.RightsID.includes('202030021') ? '/viewexpense' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteLibraryEdit = this.RightsID.includes('202030000') || this.RightsID.includes('202030001') || this.RightsID.includes('202030021') ? '/viewlibrary' : '/module/0';

    // tslint:disable-next-line: max-line-length
    this.RouteNoticeEdit = this.RightsID.includes('202030000') || this.RightsID.includes('202030001') || this.RightsID.includes('202030021') ? '/nav/notice/0/update' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteCaseEdit = this.RightsID.includes('202032000') || this.RightsID.includes('202032001') || this.RightsID.includes('202032021') ? '/nav/case/0/update' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteContactEdit = this.RightsID.includes('202034000') || this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ? '/navorgcon/0/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteOrgEdit = this.RightsID.includes('202034000') || this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ? '/navorgcon/1/0' : '/module/0';
    this.RouteDecisionImport = this.RightsID.includes('202038031') ? '/module/0' : '/module/0';
    this.RouteNoticeImport = this.RightsID.includes('202030031') ? '/import/1' : '/module/0';
    this.RouteCaseImport = this.RightsID.includes('202032031') ? '/import/2' : '/module/0';
    this.RouteContactImport = this.RightsID.includes('202034031') ? '/module/0' : '/module/0';
    this.RouteOrgImport = this.RightsID.includes('202034031') ? '/module/0' : '/module/0';
  }
  logOut() {
    localStorage.setItem('LoginID', '');
    this.router.navigate(['/login']);
  }
  OpenFlow(GenID, FlowID, Link, type, Name) {
    debugger;
    this.MsgType = type;
    this.ReportUrl = Link;


    this.ModelFor = Name;
    this.http.get(this.url + 'Dashboard/GetFlow?GenID=' + GenID + '&FlowID=' + FlowID)
      .subscribe((data) => {
        debugger
        if (data == null) {
          this.FlowData = null;
        } else {
          this.FlowData = JSON.parse(data.toString());
        }
        if (this.ReportUrl == "report/207084000/0/0/0/") {
          this.router.navigate(['/report/207084000/0/0/0/32/HLPNoticeType~2']);
        }
        else if (this.ReportUrl == "report/207089000/0/0/0/") {
          this.router.navigate(['/report/207089000/0/0/0/56/HLPNoticeType~2']);
        }
      }
      );
  }
  OpenModal(cID, modelName) {

    this.ModuleData = null;
    this.ModelFor = modelName;//
    if (cID == 110) {
      this.MsgType = 6;
      this.http.get(this.url + 'Dashboard/GetDashboardReport?GenID=' + cID)
        .subscribe((data) => {

          if (data == null) {
            this.ReportData = null;
          } else {
            this.ReportData = JSON.parse(data.toString());
          }
        }
        );
      this.http.get(this.url + 'Dashboard/GetDashboardModuleData?GenID=' + cID)
        .subscribe((data) => {

          if (data == null) {
            this.ModuleData = null;
          } else {
            this.ModuleData = JSON.parse(data.toString());
          }
        }
        );
    }
    else if (cID == 105) {
      this.MsgType = 1;
      this.http.get(this.url + 'Dashboard/GetDashboardReportModule?GenID=' + cID)
        .subscribe((data) => {

          if (data == null) {
            this.ReportData = null;
          } else {
            this.ReportData = JSON.parse(data.toString());
          }
        }
        );
    }
    else {
      this.MsgType = 0;
      this.http.get(this.url + 'Dashboard/GetDashboardModule?GenID=' + cID)
        .subscribe((data) => {

          if (data == null) {
            this.ModuleData = null;
          } else {
            this.ModuleData = JSON.parse(data.toString());
          }
        }
        );
    }
  }
  OpenModalIFrame(url, cID, urld, modelName) {

    this.modalURL =  url + "/" + cID;
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
  }
  fetchLibrary() { }
  onItemChange(value) {
    this.RadioValue = value;
  }

  readonly months = [
    { num: 1, name: 'Jan' },
    { num: 2, name: 'Feb' },
    { num: 3, name: 'Mar' },
    { num: 4, name: 'Apr' },
    { num: 5, name: 'May' },
    { num: 6, name: 'Jun' },
    { num: 7, name: 'Jul' },
    { num: 8, name: 'Aug' },
    { num: 9, name: 'Sep' },
    { num: 10, name: 'Oct' },
    { num: 11, name: 'Nov' },
    { num: 12, name: 'Dec' }
  ];

  private buildCaseChart() {

    const users = [...new Set(this.monthlyCases.map(x => x.UserName))];

    const labels = Array.from(new Set(this.monthlyCases.map(item => item.UserName)));

    const datasets = this.months.map(month => ({
      label: month.name,
      monthNumber: month.num,
      data: users.map(user => {
        const found = this.monthlyCases.find(
          d => d.MonthNumber === month.num && d.UserName === user
        );
        return found ? found.CaseCount : 0;
      }),
      backgroundColor: this.getMonthColor(month.num),
      hoverBackgroundColor: this.getMonthColor(month.num, true),
      borderRadius: 6,
      borderWidth: 1,
      barThickness: 36,
      stack: 'cases'
    }));

    this.chartData = {
      labels: users,
      datasets
    };

    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: ctx => `${ctx.dataset.label}: ${ctx.raw} cases`,
          }
        },
        title: {
          display: true,
          text: 'Monthly Pending Cases by User'
        }
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: 'Users'
          }
        },
        y: {
          stacked: true,
          beginAtZero: true,
          title: {
            display: true,
            text: 'Pending Case Count'
          },
          ticks: { precision: 0 }
        }
      },
      animation: {
        duration: 800,
        easing: 'easeOutQuart'
      },
      onClick: (event, elements) => {
          if (elements.length > 0) {
            const elementIndex = elements[0].index; // Employee index
            const datasetIndex = elements[0].datasetIndex; // Source index
            const user = labels[elementIndex];
            const monthNumber = datasets[datasetIndex].monthNumber;
            const rawItem = this.monthlyCases.find(d => d.UserName === user && d.MonthNumber === monthNumber);
            console.log(rawItem);
            if (rawItem) {
              const url = `/nav/case/0/process?UserID=${rawItem.UserID}&monthNumber=${rawItem.MonthNumber}`;
              console.log(url);
              window.open(url, '_blank');
            }
          }
      }
    };
  }

  // private buildNoticeChart() {

  //   const users = [...new Set(this.monthlyPendingNotice.map(x => x.UserName))];

  //   const datasets = this.months.map(month => ({
  //     label: month.name,
  //     data: users.map(user => {
  //       const found = this.monthlyPendingNotice.find(
  //         d => d.MonthNumber === month.num && d.UserName === user
  //       );
  //       return found ? found.PendingNoticeCount : 0;
  //     }),
  //     backgroundColor: this.getNoticeMonthColor(month.num),
  //     hoverBackgroundColor: this.getNoticeMonthColor(month.num, true),
  //     borderRadius: 6,
  //     borderWidth: 1,
  //     barThickness: 36,
  //     stack: 'cases'
  //   }));

  //   this.noticeChartData = {
  //     labels: users,
  //     datasets
  //   };

  //   this.noticeChartOptions = {
  //     responsive: true,
  //     maintainAspectRatio: false,
  //     plugins: {
  //       legend: {
  //         position: 'bottom'
  //       },
  //       tooltip: {
  //         callbacks: {
  //           label: ctx => `${ctx.dataset.label}: ${ctx.raw} notices`
  //         }
  //       },
  //       title: {
  //         display: true,
  //         text: 'Monthly Pending Notices by User'
  //       }
  //     },
  //     scales: {
  //       x: {
  //         stacked: true,
  //         title: {
  //           display: true,
  //           text: 'Users'
  //         }
  //       },
  //       y: {
  //         stacked: true,
  //         beginAtZero: true,
  //         title: {
  //           display: true,
  //           text: 'Pending Notice Count'
  //         },
  //         ticks: { precision: 0 }
  //       }
  //     },
  //     animation: {
  //       duration: 800,
  //       easing: 'easeOutQuart'
  //     }
  //   };
  // }
  private buildNoticeChart() {

    const users = [...new Set(this.monthlyPendingNotice.map(x => x.UserName))];
    const labels = Array.from(new Set(this.monthlyPendingNotice.map(item => item.UserName)));


    const datasets = this.months.map(month => ({
      label: month.name,
      monthNumber: month.num,
      data: users.map(user => {
        const found = this.monthlyPendingNotice.find(
          d => d.MonthNumber === month.num && d.UserName === user
        );
        return found ? found.PendingNoticeCount : 0;
      }),
      borderColor: this.getNoticeMonthColor(month.num),
      backgroundColor: this.getNoticeMonthColor(month.num, true),
      fill: false,
      tension: 0.35,
      pointRadius: 4,
      pointHoverRadius: 6
    }));

    this.noticeChartData = {
      labels: users,
      datasets
    };

    this.noticeChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: 'bottom' },
        tooltip: {
          callbacks: {
            label: ctx => `${ctx.dataset.label}: ${ctx.raw} notices`
          }
        },
        title: {
          display: true,
          text: 'Monthly Pending Notices by User'
        }
      },
      scales: {
        x: {
          // stacked: true,
          title: {
            display: true,
            text: 'Users'
          }
        },
        y: {
          // stacked: true,
          // beginAtZero: true,
          title: {
            display: true,
            text: 'Pending Notice Count'
          },
          // ticks: { precision: 0 }
        }
      },
      
      onClick: (event, elements) => {
          if (elements.length > 0) {
            const elementIndex = elements[0].index; // Employee index
            const datasetIndex = elements[0].datasetIndex; // Source index
            const user = labels[elementIndex];
            const monthNumber = datasets[datasetIndex].monthNumber;
            const rawItem = this.monthlyCases.find(d => d.UserName === user && d.MonthNumber === monthNumber);
            console.log(rawItem);
            if (rawItem) {
              const url = `/nav/notice/0/process?UserID=${rawItem.UserID}&monthNumber=${rawItem.MonthNumber}`;
              console.log(url);
              window.open(url, '_blank');
            }
          }
      }
    };
  }

  private getMonthColor(month: number, hover = false): string {
    const hue = (month * 30) % 360;  // evenly spaced colors
    const saturation = hover ? 80 : 65;
    const lightness = hover ? 45 : 60;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }
    private getNoticeMonthColor(month: number, hover = false): string {
    const hue = (month * 40) % 360;  // evenly spaced colors
    const saturation = hover ? 80 : 65;
    const lightness = hover ? 45 : 60;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }


  bindBarChart() {
    // Generate rainbow colors dynamically
    const generateRainbowColors = (numColors: number) => {
      const colors: string[] = [];
      for (let i = 0; i < numColors; i++) {
        const hue = Math.round((i / numColors) * 360);
        colors.push(`hsl(${hue}, 80%, 55%)`);
      }
      return colors;
    };

    // Apply rainbow colors based on number of bars
    const backgroundColors = generateRainbowColors(this.monthlyCases.length);

    this.barChartLabels = this.monthlyCases.map(x => x.MonthName);
    this.barChartData = [
      {
        data: this.monthlyCases.map(x => x.NoticeCount),
        label: 'Case Count',
        backgroundColor: backgroundColors,  // 🌈 rainbow colors
        borderColor: '#ffffff',
        hoverBackgroundColor: backgroundColors,
        hoverBorderColor: '#000000',
        barThickness: 'flex',
        maxBarThickness: 40,
        categoryPercentage: 0.6,
        barPercentage: 0.7
      }
    ];
  }

  prepareChart() {

    const points = this.monthlyPendingNotice.map(item => ({
      x: new Date(item.TargetDate),
      y: parseInt(item.DueStatus.replace(/\D/g, '')),
      refno: item.refno
    }));

    points.sort((a, b) => a.x - b.x);

    this.dueTrendData = {
      datasets: [
        {
          label: 'Due Days Trend',
          data: points,
          borderWidth: 1.5,
          tension: 0.3,
          fill: false,
          pointRadius: 3,
          pointHoverRadius: 5,
          borderColor: '#1a3585'
        }
      ]
    };

    this.dueTrendOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'day',
            tooltipFormat: 'PP'
          },
          title: {
            display: true,
            text: 'Target Date'
          }
        },
        y: {
          title: {
            display: true,
            text: 'Due Days'
          },
          beginAtZero: true
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: (context) => {
              const p: any = context.raw;
              return `Ref: ${p.refno} | ${p.y} days`;
            }
          }
        },
        legend: { display: true }
      }
    };
  }

}
